import React, { useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { BsThreeDotsVertical, BsPlus } from "react-icons/bs";
import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaUsers,
  FaDollarSign,
  FaEye,
} from "react-icons/fa";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Container } from "react-bootstrap";
import SportsIMg from "../../assets/img/sports.jpg";

// img

const genderData = [
  { name: "Boys", value: 1500 },
  { name: "Girls", value: 1000 },
];

const attendanceData = [
  { day: "Mon", present: 250, absent: 80 },
  { day: "Tue", present: 210, absent: 50 },
  { day: "Wed", present: 230, absent: 70 },
  { day: "Thu", present: 180, absent: 60 },
  { day: "Fri", present: 220, absent: 65 },
  { day: "Sat", present: 260, absent: 40 },
];

const COLORS = ["#8451ff", "#2ED8C3"];

export default function SAdminHome() {
  const [calendarDate, setCalendarDate] = useState(new Date());

  const notices = [
    {
      id: 1,
      title: "School annual sports day celebration 2023",
      date: "20 July, 2023",
      views: "20k",
      img: SportsIMg,
      highlight: true,
    },
    {
      id: 2,
      title: "Annual Function celebration 2023-24",
      date: "05 July, 2023",
      views: "15k",
      img: SportsIMg,
    },
    {
      id: 3,
      title: "Mid term examination routine published",
      date: "15 June, 2023",
      views: "22k",
      img: SportsIMg,
    },
    {
      id: 4,
      title: "Inter school annual painting competition",
      date: "18 May, 2023",
      views: "18k",
      img: SportsIMg,
    },
    {
      id: 5,
      title: "Mid term examination routine published",
      date: "15 June, 2023",
      views: "22k",
      img: SportsIMg,
    },
    {
      id: 6,
      title: "Mid term examination routine published",
      date: "15 June, 2023",
      views: "22k",
      img: SportsIMg,
    },
  ];
  return (
    <>
      <div className="homepage-container">
        <Container className="dh-container">
          <div className="countdetails-wrapper">
            <div className="countdetails-card">
              <div className="countdetails-icon">
                <FaUserGraduate />
              </div>
              <div className="countdetails-text">
                <p>Total Students</p>
                <h3>2500</h3>
              </div>
            </div>

            <div className="countdetails-card">
              <div className="countdetails-icon">
                <FaChalkboardTeacher />
              </div>
              <div className="countdetails-text">
                <p>Total Teachers</p>
                <h3>150</h3>
              </div>
            </div>

            <div className="countdetails-card">
              <div className="countdetails-icon">
                <FaUsers />
              </div>
              <div className="countdetails-text">
                <p>Total Employee</p>
                <h3>600</h3>
              </div>
            </div>

            <div className="countdetails-card">
              <div className="countdetails-icon">
                <FaDollarSign />
              </div>
              <div className="countdetails-text">
                <p>Total Earnings</p>
                <h3>$10,000</h3>
              </div>
            </div>
          </div>

          <div className="dh-middle">
            {/* Gender Chart */}
            <div className="dh-card">
              <h4>Total Students by Gender</h4>
              <div className="dh-pie-wrap">
                <PieChart width={220} height={220}>
                  <Pie
                    data={genderData}
                    innerRadius={70}
                    outerRadius={100}
                    dataKey="value"
                  >
                    {genderData.map((_, i) => (
                      <Cell key={i} fill={COLORS[i]} />
                    ))}
                  </Pie>
                </PieChart>
                <div className="dh-pie-center">2500</div>
              </div>

              <div className="dh-legend">
                <span>
                  <i className="boy"></i>Boys: 1500
                </span>
                <span>
                  <i className="girl"></i>Girls: 1000
                </span>
              </div>
            </div>

            {/* Attendance */}
            <div className="dh-card dh-attendance-card">
              {/* Header */}
              <div className="dh-attendance-head">
                <h4>Attendance</h4>

                <div className="dh-attendance-filters">
                  <select>
                    <option>This week</option>
                  </select>
                  <select>
                    <option>Class 10</option>
                  </select>
                </div>
              </div>

              {/* Legend */}
              <div className="dh-attendance-legend">
                <span>
                  <i className="legend-present"></i> Total Present
                </span>
                <span>
                  <i className="legend-absent"></i> Total Absent
                </span>
              </div>
              {/* Chart */}
              <div className="dh-attendance-chart">
                <ResponsiveContainer width="100%" height={260}>
                  <BarChart data={attendanceData} barGap={10}>
                    <CartesianGrid
                      vertical={false}
                      strokeDasharray="4 4"
                      stroke="#e5e7eb"
                    />
                    <XAxis dataKey="day" axisLine={false} tickLine={false} />
                    <YAxis axisLine={false} tickLine={false} />

                    {/* hover */}
                    <Tooltip
                      cursor={{ fill: "transparent" }}
                      content={<AttendanceTooltip />}
                    />

                    <Bar
                      dataKey="present"
                      fill="#8451ff"
                      radius={[6, 6, 0, 0]}
                      barSize={22}
                    />
                    <Bar
                      dataKey="absent"
                      fill="#2ED8C3"
                      radius={[6, 6, 0, 0]}
                      barSize={22}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
          <div className="dh-bottom">
            {/* Notice Board */}
            <div className="nb-card">
              {/* Header */}
              <div className="nb-header">
                <h4>Notice Board</h4>
                <button className="nb-add-btn">
                  <BsPlus />
                </button>
              </div>

              {/* List */}
              <div className="nb-list">
                {notices.map((item) => (
                  <div className="nb-item" key={item.id}>
                    <img src={item.img} alt="notice" className="nb-thumb" />

                    <div className="nb-content">
                      <p className="nb-title">{item.title}</p>
                    </div>
                    <div className="nb-daterow d-flex">
                      <span
                        className={`nb-date ${item.highlight ? "active" : ""}`}
                      >
                        {item.date}
                      </span>

                      <div className="nb-views">
                        <span className="nb-eye">
                          <FaEye />
                        </span>
                        <span>{item.views}</span>
                      </div>

                      <button className="nb-more">
                        <BsThreeDotsVertical />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* Event Calendar */}
            <div className="dh-card dh-calendar-card">
              <div className="dh-calendar-head">
                <h4>Event Calendar</h4>
                <span className="dh-calendar-more">•••</span>
              </div>

              <Calendar
                onChange={setCalendarDate}
                value={calendarDate}
                showNeighboringMonth={false}
                next2Label={null}
                prev2Label={null}
                formatShortWeekday={(locale, date) =>
                  date.toLocaleDateString(locale, { weekday: "short" })
                }
              />
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}

/* ---------------> SMALL COMPONENTS  <--------------- */

const AttendanceTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="dh-att-tooltip">
        <p className="dh-att-day">{label}</p>
        <p className="present">
          ● Present: {payload.find((p) => p.dataKey === "present")?.value}
        </p>
        <p className="absent">
          ● Absent: {payload.find((p) => p.dataKey === "absent")?.value}
        </p>
      </div>
    );
  }
  return null;
};
